import React, { useState } from 'react'
import { Button, BUTTON_THEME, Icon, IconButton, Input } from '@st-operations/uikit/src/v2/index.js'

import RectLoader from '_components/rect-loader/index.jsx'
import ColoredCheckbox from '_components/colored-checkbox/index.jsx'
import { LINE_COLORS } from '../trends-constants.js'
import { UIKIT_COLORS } from '../../scale-and-coverage/constants.js'
import { useDropdown, useModal } from '_hooks'
import { ConfirmPrompt } from '_components/confirm-prompt/index.jsx'
import KeccTopDomainsModal from '../../kecc/kecc-top-domains-modal/index.jsx'

import './styles.scss'

const TrendsSidebar = ({
  field,
  title,
  trendsData = [],
  transformLineLabel = (key) => key,
  linesSelection = [],
  onLinesSelectionChange = () => {},
  hoveredKeyword,
  onHoveredKeywordChange = () => {},
  loading,
  fixedLines = [],
  separatorIndexes = [],
  onRemoveValue = () => {},
  onSettingsClick = () => {},
  onClearAllClick = () => {},
  onAddTermQuickClick = () => {},
}) => {
  const dumbArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

  const [term, setTerm] = useState()
  const [isConfirmClearAllOpen, setIsConfirmClearAllOpen] = useState()
  const {
    isOpen: isTopDomainsModalOpen,
    handleCloseModal: handleTopDomainsModalClose,
    handleOpenModal: handleTopDomainsModalOpen,
  } = useModal()
  const [clickedWord, setClickedWord] = useState()

  const {
    isOpen: addTermQuickModalIsOpen,
    handleOpen: handleAddTermQuickOpen,
    handleClose: handleAddTermQuickClose,
    dropdownRef: addTermQuickModalRef,
  } = useDropdown()

  const handleAddTermQuickSave = (e, term) => {
    handleAddTermQuickClose()
    onAddTermQuickClick(e, term)
    setTerm('')
  }

  const handleAddTermQuickExpand = () => {
    handleAddTermQuickClose()
    onSettingsClick()
    setTerm('')
  }

  return (
    <section className="trends-sidebar">
      <div className="trends-sidebar__header">
        <h3 className="trends-sidebar__header-title">{title}</h3>
        <div className="trends-sidebar__header-buttons">
          <IconButton
            className="trends-sidebar__header-buttons-item"
            text="Settings"
            iconProps={{ icon: 'settings', type: 'outline' }}
            onClick={onSettingsClick}
          />
          <IconButton
            className="trends-sidebar__header-buttons-item"
            text="Clear All"
            iconProps={{ icon: 'trashcan', type: 'outline' }}
            onClick={() => setIsConfirmClearAllOpen(true)}
          />
        </div>
      </div>
      <ul className="trends-sidebar__list">
        <If condition={!loading}>
          <For each="lineName" index="index" of={[...fixedLines, ...Object.keys(trendsData)]}>
            <li
              className="trends-sidebar__list-item"
              onMouseEnter={() => onHoveredKeywordChange(lineName)}
              onMouseLeave={() => onHoveredKeywordChange(undefined)}
            >
              <ColoredCheckbox
                color={
                  LINE_COLORS[Object.keys(trendsData).findIndex((f) => f === lineName)] || 'black'
                }
                checked={linesSelection[lineName]}
                onCheckedChange={(value) =>
                  onLinesSelectionChange({ ...linesSelection, [lineName]: value })
                }
              />
              <If condition={trendsData[lineName] !== null}>
                <span
                  className="trends-sidebar__list-item-text"
                  style={
                    hoveredKeyword && hoveredKeyword !== lineName
                      ? { color: '#eee', flex: 1 }
                      : { flex: 1 }
                  }
                  onClick={() => {
                    setClickedWord(lineName)
                    handleTopDomainsModalOpen()
                  }}
                >
                  {transformLineLabel(lineName)}
                </span>
                <If condition={hoveredKeyword === lineName && !fixedLines.includes(lineName)}>
                  <div
                    style={{ width: 24, height: 24, marginRight: 23 }}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()

                      onRemoveValue(
                        lineName,
                        index > separatorIndexes[0] && index <= separatorIndexes[1]
                      )
                    }}
                  >
                    <Icon type="outline" icon="trashcan" width={24} height={24} />
                  </div>
                </If>
              </If>
            </li>
            <If condition={separatorIndexes.includes(index)}>
              <div className="trends-sidebar__separator" />
            </If>
          </For>
        </If>
        <If condition={loading}>
          <For each="i" index="index" of={dumbArray}>
            <li className="trends-sidebar__list-item">
              <RectLoader width={24} height={24} />
              <RectLoader width={300} height={24} />
            </li>
            <If condition={separatorIndexes.includes(index)}>
              <div className="trends-sidebar__separator" />
            </If>
          </For>
        </If>
      </ul>
      <div style={{ flex: 1 }} />
      <div>
        <div className="trends-sidebar__add-filter">
          <div onClick={handleAddTermQuickOpen} className="trends-sidebar__add-filter-label">
            <Icon type="fill" icon="plus2" width={16} height={16} color={UIKIT_COLORS.ds_green} />
            <span className="trends-sidebar__add-filter-label" style={{ marginLeft: 10 }}>
              New {title}
            </span>
          </div>
          <If condition={addTermQuickModalIsOpen}>
            <div ref={addTermQuickModalRef} className="trends-sidebar__add-term-quick-dialog">
              <Input
                label={title}
                value={term}
                onChange={(value) => setTerm(value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleAddTermQuickSave(e, term)
                  }
                }}
              />
              <div className="trends-sidebar__add-term-quick-dialog-buttons">
                <IconButton
                  iconProps={{ type: 'outline', icon: 'expand' }}
                  onClick={handleAddTermQuickExpand}
                />
                <div className="trends-sidebar__add-term-quick-dialog-buttons-2">
                  <Button theme={BUTTON_THEME.GHOST} onClick={handleAddTermQuickClose}>
                    Cancel
                  </Button>
                  <Button onClick={(e) => handleAddTermQuickSave(e, term)}>Save</Button>
                </div>
              </div>
            </div>
          </If>
          <ConfirmPrompt
            title="Remove all entities?"
            description="Changes you made so far will not be saved."
            okText="Yes, remove all"
            cancelText="No"
            isOpen={isConfirmClearAllOpen}
            onIsOpenChange={(value) => setIsConfirmClearAllOpen(value)}
            onOK={onClearAllClick}
          />
          <KeccTopDomainsModal
            field={field}
            word={clickedWord}
            isOpen={isTopDomainsModalOpen}
            onClose={handleTopDomainsModalClose}
          />
        </div>
      </div>
    </section>
  )
}

export default TrendsSidebar
